import script from "./WelcomeMobileModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeMobileModal.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeMobileModal.vue?vue&type=style&index=0&id=e0fcd258&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0fcd258"]])

export default __exports__